import React, { Component } from 'react';
import { MenuItem, SelectField, Dialog, FlatButton, RaisedButton } from 'material-ui';
import Box from '../ui/Box';

//services
import DataService from '../../services/DataService'; var ds = DataService;

var BUTTON_TYPES = {
  kiot_5_button: 1
}

export default class ManageServiceButtonsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      device_type: "",
      device_types: {},
      all_services: [],
      all_devices: [],
      filtered_devices: [],
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getDeviceTypes();
    this.getAllServices();
  }

  handleChanges_type(e, i, val) {
    this.setState({
      device_type: val
    }, () => {
      this.filterDevices();
    })
  }
  getAllServices() {
    ds.getAllButtonServices(
      data => {
        if (data && data.docs) {
          this.setState({
            all_services: data.docs
          })
        }
      }, err => {}
    )
  }

  filterDevices() {
    let x = [];
    for (let i of this.state.all_devices) {
      if (this.state.device_type == i.device_type) {
        x.push(i);
      }
    }
    this.setState({
      filtered_devices: x
    });
  }

  getDeviceTypes() {
    ds.getDevicesTypes(
      data => {
        if (data && data.length) {
          let x = {};
          for (let i of data) {
            if (i.identifier && BUTTON_TYPES[i.identifier]) {
              x[i._id] = i;
            }
          }
          this.setState({
            device_types: x
          }, () => {
            this.getAllDevices();
          })
        }
      }, err => {}
    )
  }

  getAllDevices() {
    ds.getDevicesInHotel(
      data => {
        if (data && data.length) {
          let x = [];
          for (let i of data) {
            if (this.state.device_types[i.device_type]) {
              x.push(i);
            }
          }
          this.setState({
            all_devices: x
          })
        }
      }, 
      err => {}
    )
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
  }

  saveButtonConf(e) {
    e.preventDefault();
    if (this.validated()) {
      ds.postSaveServiceButtonPrefs(
        this.getPayload(), 
        data => {
          this.setState({
            dialog: {
              open: true,
              head: 'Done',
              body: 'Services for buttons are saved',
              actions: [
                <FlatButton
                  label="Okay"
                  primary
                  onClick={this.closeDialog.bind(this)}
                />
              ]
            }
          })
        }, 
        err => {}
      )
    }
  }

  getPayload() {
    let payload = { mapping: [] };
    let buttons = [];
    let c = 0;
    for (let i of this.state.device_types[this.state.device_type].switch_struct) {
      if (this.state.device_types[this.state.device_type] && this.state.device_types[this.state.device_type][`button${c + 1}`]) {
        buttons.push({
          button_no: c + 1,
          service_id: this.state.device_types[this.state.device_type][`button${c + 1}`]
        })
      }
      c++;
    }
    for (let i of this.state.values) {
      payload.mapping.push({
        kd_id: i,
        map: buttons
      })
    }
    return payload;
  }

  validated() {
    let _valid = true;
    if (!this.state.device_type) {
      this.setState({
        dialog: {
          open: true,
          head: 'Invalid',
          body: 'Please select a device type',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
      _valid = false;
    }
    else if (!this.state.values || !this.state.values.length) {
      this.setState({
        dialog: {
          open: true,
          head: 'Invalid',
          body: 'Please select atleast one device',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      })
      _valid = false;
    }
    return _valid;
  }

  render() {
    return (
      <Box header='Assign Service Buttons'>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>


        <div>
          <div>
            <form onSubmit={this.saveButtonConf.bind(this)}>
              <fieldset>
                <section>
                  <SelectField
                    floatingLabelText="Device Type"
                    value={this.state.device_type}
                    name="device_type"
                    className="w-100"
                    onChange={this.handleChanges_type.bind(this)} >
                    <MenuItem value={null} primaryText="Select" />
                    {
                      this.state.device_types && Object.keys(this.state.device_types).length ?
                        Object.keys(this.state.device_types).map((i) => {
                          return (<MenuItem key={i} value={this.state.device_types[i]._id} primaryText={this.state.device_types[i].alias_name} />);
                        }) 
                      : null
                    }
                  </SelectField>
                </section>

                {
                  this.state.device_type ? 
                    <div className="row">
                      <section className="col-sm-10">
                        <SelectField
                          multiple={true}
                          floatingLabelText="Devices"
                          value={this.state.values}
                          onChange={(event, index, values) => this.setState({ values })}
                          className="w-100">
                          {this.state.filtered_devices && this.state.filtered_devices.length ?
                            this.state.filtered_devices.map((device) => {
                              return <MenuItem key={device._id} value={device.kd_id} primaryText={device.device_name} />
                            }) : null
                          }
                        </SelectField>
                      </section>

                      <section className="col-sm-2" style={{ lineHeight: "6vw", textAlign: "right" }}>
                        <FlatButton
                          label="Select All"
                          onClick={(e) => {
                            let x = []
                            for (let i of this.state.filtered_devices) {
                              x.push(i.kd_id);
                            }
                            this.setState({
                              values: x
                            })
                          }}
                          primary
                          type="button"
                        />
                      </section>
                    </div> 
                  : null
                }

                {
                  this.state.device_type && this.state.values && this.state.values.length ?
                    this.state.device_types[this.state.device_type].switch_struct.map((device_type, ind) => {
                      return <section className="col-sm-6">
                        <SelectField
                          floatingLabelText={`Service for Button ${ind + 1}`}
                          value={this.state.device_types[this.state.device_type][`button${ind + 1}`]}
                          onChange={(e, some, val) => {
                            let x = this.state.device_types;
                            x[this.state.device_type][`button${ind + 1}`] = val;
                            this.setState({
                              device_types: x
                            })
                          }}
                          className="w-90">
                          {
                            this.state.all_services && this.state.all_services.length ?
                              this.state.all_services.map((service) => {
                                return <MenuItem key={service._id} value={service._id} primaryText={service.name} />
                              }) : null
                          }
                        </SelectField>
                      </section>
                    }) 
                  : null
                }
              </fieldset>

              <div className="mt-4vw align-right">
                <RaisedButton
                  label="Save"
                  primary
                  type="submit"
                />
              </div>
            </form>

          </div>
        </div>
      </Box>
    )
  }

}


// WEBPACK FOOTER //
// ./components/services/ManageServiceButtonsComponent.js